import { flow, types } from 'mobx-state-tree'
import { extendAppSessionAPI } from '../../network/ExtendAppSession'
import { extendUserSessionAPI } from '../../network/ExtendUserSession'
import { downloadFile } from '../../network/downloadFile'
import { fileUploadApproval } from '../../network/fileUploadApproval'
import { getAllFiles } from '../../network/getAllFiles'
import { uploadFile } from '../../network/uploadFile'
import { MessageTypes, getErrorMessage } from '../../utils'
import { ROUTING_PACKAGE_FILETYPE } from '../../utils/constants'
import { RootStore } from '../store'

const file = types.model('file', {
  id: types.optional(types.number, 0),
  fileName: types.optional(types.string, ''),
  fromDate: types.optional(types.string, ''),
  toDate: types.optional(types.string, ''),
  duration: types.optional(types.string, ''),
  status: types.optional(types.string, ''),
  link: types.optional(types.string, ''),
  uploadedBy: types.optional(types.string, ''),
  originalFileName: types.optional(types.string, ''),
})
export const FileUpload = types
  .model('FileUpload', {
    id: types.optional(types.number, 0),
    files: types.array(file),
  })
  .actions((self) => ({
    fetchAllFiles: flow(function* fetchAllFiles(data: any, pagination: any) {
      try {
        const response = yield getAllFiles(data, pagination, ROUTING_PACKAGE_FILETYPE, RootStore.session.getTokens)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    download: flow(function* download(path: string, fileName: string, saveFileName: string, fileExt?: string) {
      const params = '?fp=' + path + '&fn=' + fileName + '&fileType=0'
      try {
        let errorCode = ''
        const resp: any = yield downloadFile(params, RootStore.session.getTokens)
        try {
          const errorFileResponse =
            resp?.data?.status !== 'SUCCESS' && JSON.parse(Buffer.from(resp?.data).toString('utf8'))
          errorCode = errorFileResponse?.error?.code ?? errorFileResponse?.meta?.code ?? ''
          if (errorCode === '33607' || errorCode === '33306') {
            if (errorCode === '33607') {
              extendUserSessionAPI().then((response) => {
                console.log('extendUserSessionAPI response', response)
                return (self as any).download(path, fileName, saveFileName)
              })
            } else {
              extendAppSessionAPI().then((response) => {
                console.log('extendAppSessionAPI response', response)
                return (self as any).download(path, fileName, saveFileName)
              })
            }
          } else {
            RootStore.message.setMessage(errorFileResponse?.meta?.message, MessageTypes.ERROR)
            throw errorFileResponse?.meta?.message
          }
        } catch (err) {
          console.log(err)
        }
        if (window && errorCode === '' && resp && resp?.data) {
          let mimeType = resp.headers['Content-Type']
          const blob = new Blob([resp?.data], {
            mimeType,
          })
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          document.body.appendChild(a)
          a.href = url
          a.download = saveFileName + (fileExt ? '.' + fileExt : '')
          a.click()
          window.URL.revokeObjectURL(url)
          document.body.removeChild(a)
        }
        return resp
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    fileUpload: flow(function* fileUpload(file: any) {
      try {
        const resp = yield uploadFile(file, RootStore.session.getTokens, ROUTING_PACKAGE_FILETYPE)
        let errorCode = ''
        try {
          errorCode = resp?.data?.error?.code ?? ''
          if (errorCode === '33607' || errorCode === '33306') {
            if (errorCode === '33607') {
              extendUserSessionAPI().then((response) => {
                console.log('extendUserSessionAPI response', response)
                return (self as any).fileUpload(file)
              })
            } else {
              extendAppSessionAPI().then((response) => {
                console.log('extendAppSessionAPI response', response)
                return (self as any).fileUpload(file)
              })
            }
          }
        } catch (err) {
          console.log(err)
        }
        if (errorCode === '') {
          RootStore.message.setMessage(resp?.data?.message ?? 'File Upload Success', MessageTypes.SUCCESS)
        }
        return resp
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    processApprovals: flow(function* processApprovals(data: any) {
      try {
        const response = yield fileUploadApproval(data, RootStore.session.getTokens, ROUTING_PACKAGE_FILETYPE)
        RootStore.message.setMessage(response?.message ?? 'Added entity', MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
  }))
  .views((self) => ({
    getFiles() {
      return JSON.parse(JSON.stringify(self.files))
    },
    getFilteredFileUploadList(listData: any, keys?: any, searchText?: any) {
      const list = listData ?? self?.files ?? []
      const data = list?.map((item: any) => {
        return {
          ...item,
        }
      })
      if (keys?.length > 0) {
        if (data.length > 0) {
          if (keys && keys?.length > 0) {
            const retArr: any = []
            data.map((item: any) => {
              let isMatching = true
              keys.map((obj: any) => {
                const val = isNaN(item[obj?.key]) ? item[obj?.key].toLowerCase() : item[obj?.key]?.toString()
                isMatching = isMatching && val.includes(obj?.searchString.toLowerCase())
              })
              isMatching && retArr.push(item)
              return retArr
            })
            return retArr
          } else {
            return listData?.filter((obj: any) =>
              Object.keys(obj).some((key) => obj[key].toLowerCase().includes(searchText.toLowerCase())),
            )
          }
        }
      }
      return data
    },
  }))

export const fileUploadData = FileUpload.create({
  id: 0,
  files: [],
})
